import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0533e6cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-overdue-tj" }
const _hoisted_2 = { class: "filter-bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "区间时间：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"16px"} }, "流程名称：", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"#909399","font-size":"12px","margin-top":"8px"} }, " 逾期判定：执行人签字时间 晚于 节点要求完成时间；区间时间按执行人签字时间过滤。 ", -1))
const _hoisted_8 = { style: {"color":"#f56c6c"} }

import { ref } from 'vue'
	import { ElMessage } from 'element-plus'
	import { reqFormInstanceOverdueStat, reqFormInstanceOverdueDetail } from '@/api/forminstanceApi'

	
export default /*#__PURE__*/_defineComponent({
  name: 'formoverduetj',
  setup(__props) {

	const dateRange = ref<any>(null)
	const formname = ref<string>('')
	const statList = ref<any[]>([])
	const loading = ref<boolean>(false)

	const detailVisible = ref<boolean>(false)
	const detailTitle = ref<string>('逾期明细')
	const detailList = ref<any[]>([])
	const detailLoading = ref<boolean>(false)

	// 分钟数转为“X天Y小时 / Y小时Z分钟”的可读文本
	const overdueText = (minutes: any) => {
		const m = Number(minutes) || 0
		if (m <= 0) return '0分钟'
		const d = Math.floor(m / 1440)
		const h = Math.floor((m % 1440) / 60)
		const mi = m % 60
		if (d > 0) return `${d}天${h}小时`
		if (h > 0) return `${h}小时${mi}分钟`
		return `${mi}分钟`
	}

	const buildParams = () => {
		const p: any = {}
		if (dateRange.value && dateRange.value.length === 2) {
			p.starttime = dateRange.value[0]
			p.endtime = dateRange.value[1]
		}
		if (formname.value && formname.value.trim()) {
			p.formname = formname.value.trim()
		}
		return p
	}

	const queryStat = () => {
		loading.value = true
		reqFormInstanceOverdueStat(buildParams()).then((res: any) => {
			if (res.status === 1) {
				statList.value = res.datalist || []
			} else {
				ElMessage.error(res.msg || '查询失败')
				statList.value = []
			}
		}).finally(() => {
			loading.value = false
		})
	}

	const resetFilter = () => {
		dateRange.value = null
		formname.value = ''
		statList.value = []
	}

	const openDetail = (row: any) => {
		detailTitle.value = `执行人：${row.executor}（逾期 ${row.overduecount} 次，累计 ${overdueText(row.overdueminutes)}）`
		detailVisible.value = true
		detailLoading.value = true
		detailList.value = []
		const p = buildParams()
		p.executor = row.executor
		reqFormInstanceOverdueDetail(p).then((res: any) => {
			if (res.status === 1) {
				detailList.value = res.datalist || []
			} else {
				ElMessage.error(res.msg || '查询失败')
			}
		}).finally(() => {
			detailLoading.value = false
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateRange).value = $event)),
        type: "daterange",
        "range-separator": "至",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        "value-format": "YYYY-MM-DD",
        size: "default",
        style: {"width":"260px"}
      }, null, 8, ["modelValue"]),
      _hoisted_4,
      _createVNode(_component_el_input, {
        modelValue: formname.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formname).value = $event)),
        placeholder: "请输入签字流程名称",
        clearable: "",
        size: "default",
        style: {"width":"220px"}
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "default",
        onClick: queryStat,
        style: {"margin-left":"16px"}
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        size: "default",
        onClick: resetFilter
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _hoisted_7,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      data: statList.value,
      border: "",
      stripe: "",
      style: {"width":"100%","margin-top":"14px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          label: "序号",
          width: "70",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          prop: "executor",
          label: "执行人",
          "min-width": "140"
        }),
        _createVNode(_component_el_table_column, {
          prop: "overduecount",
          label: "逾期次数",
          width: "120",
          align: "center",
          sortable: ""
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_el_button, {
              type: "text",
              onClick: ($event: any) => (openDetail(scope.row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(scope.row.overduecount), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "累计逾期时间",
          width: "160",
          align: "center",
          sortable: "",
          prop: "overdueminutes"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("span", null, _toDisplayString(overdueText(scope.row.overdueminutes)), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    (!loading.value && statList.value.length===0)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 0,
          description: "暂无逾期记录",
          style: {"margin-top":"30px"}
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: detailVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((detailVisible).value = $event)),
      title: detailTitle.value,
      width: "900px",
      "append-to-body": ""
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: detailList.value,
          border: "",
          stripe: "",
          style: {"width":"100%"},
          "max-height": "460"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              type: "index",
              label: "序号",
              width: "60",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              prop: "formname",
              label: "签字流程名称",
              "min-width": "150",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "projectname",
              label: "项目名称",
              "min-width": "140",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "tasktitle",
              label: "任务标题",
              "min-width": "150",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "stepdesc",
              label: "流程环节",
              "min-width": "140",
              "show-overflow-tooltip": ""
            }),
            _createVNode(_component_el_table_column, {
              prop: "steptime",
              label: "要求完成时间",
              width: "150"
            }),
            _createVNode(_component_el_table_column, {
              prop: "executorsigntime",
              label: "执行人签字时间",
              width: "150"
            }),
            _createVNode(_component_el_table_column, {
              label: "逾期时长",
              width: "120",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", _hoisted_8, _toDisplayString(overdueText(scope.row.overdueminutes)), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, detailLoading.value]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})